import { render } from "./TwitterIcon.vue?vue&type=template&id=77657388"
const script = {}
script.render = render

export default script